import Resume from './resume'

export default Resume
